import React, { useState, useEffect, useRef } from "react"

import { Container, SectionLink } from "./styles"

const PageNavigation = ({
  items,
  sectionRefs,
  buttonElement,
  dataId,
  hideOnPageLoad,
  hideMainNavOnMobile,
  ...props
}) => {
  const containerRef = useRef(null)
  const [activeEl, setActiveEl] = useState(null)
  const activeItemIdx = items?.findIndex((item) => activeEl?.current.id === item.anchor)

  useEffect(() => {
    if (typeof window === "undefined" || !sectionRefs) {
      return undefined
    }
    const scrollHandler = () => {
      // take the nav and sub-nav out of the equation
      const actualScrollY = window.scrollY
      const active = sectionRefs.find(
        ({ current }) =>
          current &&
          actualScrollY >= current.offsetTop &&
          actualScrollY <= current.offsetTop + current.offsetHeight,
      )
      setActiveEl(active)
    }

    document.addEventListener("scroll", scrollHandler)
    return () => document.removeEventListener("scroll", scrollHandler)
  }, [sectionRefs, setActiveEl])

  useEffect(() => {
    const widthArray = []
    let accumulateWidht = 0
    Array.from(containerRef.current.children[0].children).forEach((child) => {
      accumulateWidht = accumulateWidht + child.offsetWidth + 25
      widthArray.push(accumulateWidht)
    })
    if (activeItemIdx === -1) return
    if (activeItemIdx === 0) {
      containerRef.current.scrollTo({ left: 0, behavior: "smooth" })
    } else {
      containerRef.current.scrollTo({ left: widthArray[activeItemIdx - 1], behavior: "smooth" })
    }
  }, [activeItemIdx])

  return (
    <Container
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      {...props}
      ref={containerRef}
      hideMainNavOnMobile={hideMainNavOnMobile}
    >
      <div>
        {items?.map((item) => (
          <SectionLink
            key={item.anchor}
            href={`#${item.anchor}`}
            selected={activeEl && activeEl.current.id === item.anchor}
            onClick={(ev) => {
              ev.preventDefault()
              window.history.pushState({}, "", `#${item.anchor}`)
              const element = document.querySelector(`#${item.anchor}`)

              if (element) {
                window.scrollTo({
                  top: element.offsetTop,
                  left: 0,
                  behavior: "smooth",
                })
              }
            }}
            title={item.text}
          >
            {item.text}
          </SectionLink>
        ))}
      </div>
      {buttonElement && buttonElement}
    </Container>
  )
}

export default PageNavigation
